module.exports = __webpack_public_path__ + "img/thumbnail_Blackbuck_f_normal.24557d88.png";